export const getHeaderId = (
  documents: Array<IDocumentWithTypeV2<'pbaS'>>,
  editing?: string,
  viewing?: string,
): string => {
  if (!editing && !viewing) return 'behaviour.title';
  const { _type } = documents.find(d => d._id === (editing ?? viewing)) ?? {};
  if (_type) {
    return `behaviour.${_type}.${_type}`;
  }
  return 'behaviour.title';
};
